import React, { useEffect, useState } from "react";
import { apiGetUserSettings, apiPostUserSettings } from "../../services/api.js/backend";
import classes from "./admin.module.css";
import BVAButton from "../BVAButton/BVAButton";
import Navbar from "../../pages/Dashboard/Navbar";
import toast from "react-hot-toast";

const AdminSettings = () => {
  const [editState, setEditState] = useState(false);
  const [securityTax, setSecurityTax] = useState("...");
  const [medicareTax, setMedicareTax] = useState("...");
  const [growthRate, setGrowthRate] = useState("...");
  const [stateTax, setStateTax] = useState("...");
  const [federalTax, setFederalTax] = useState("...");
  const [loading, setLoading] = useState(false);

  const getUserSettings = async () => {
    const response = await apiGetUserSettings();

    setSecurityTax(response?.securityTax.toFixed(2));
    setMedicareTax(response?.medicareTax.toFixed(2));
    setGrowthRate(response?.growthRate.toFixed(2));
    setStateTax(response?.stateTax.toFixed(2));
    setFederalTax(response?.federalTax.toFixed(2));
  };

  const updateUserSettings = async () => {
    const payload = {
      securityTax: Number(securityTax),
      medicareTax: Number(medicareTax),
      growthRate: Number(growthRate),
      stateTax: Number(stateTax),
      federalTax: Number(federalTax),
    };

    try {
      setLoading(true);
      await apiPostUserSettings(payload);
      toast.success("Updated Successfully.");
      setLoading(false);
    } catch (error) {
      toast.error("Unable to update.");
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!editState) {
      setEditState(true);
      return;
    }
    
    await updateUserSettings();
    handleCancel();
  };
  
  const handleCancel = async () => {
    await getUserSettings();
    setEditState(false);
  }

  const handleChange = (e) => {
    e.target.name === "securityTax" && setSecurityTax(e.target.value);
    e.target.name === "medicareTax" && setMedicareTax(e.target.value);
    e.target.name === "growthRate" && setGrowthRate(e.target.value);
    e.target.name === "stateTax" && setStateTax(e.target.value);
    e.target.name === "federalTax" && setFederalTax(e.target.value);
  }

  useEffect(() => {
    getUserSettings();
  }, []);

  return (
    <div>
      <Navbar />
      <div className={`${classes.formContainer}`}>
        <div className={`${classes.innerContainer}`}>
          <h1 className={classes.heading}>General Settings</h1>
          <form onSubmit={handleSubmit}>
            <div style={editState ? { gridTemplateColumns: "130px 1fr" } : undefined} className={`${classes.grid}`} >
              <label htmlFor="securityTax">
                <strong>Social Security Taxes:</strong>
              </label>
              {!editState && (<p>{securityTax}%</p>)}
              {editState && (
                <input
                  type="number"
                  id="securityTax"
                  name="securityTax"
                  value={securityTax}
                  placeholder="Social Security Taxes"
                  onChange={handleChange}
                  className={"input-error"}
                />
              )}
            </div>

            <div style={editState ? { gridTemplateColumns: "130px 1fr" } : undefined} className={`${classes.grid}`} >
              <label htmlFor="securityTax">
                <strong>Medicare Taxes:</strong>
              </label>
              {!editState && (<p>{medicareTax}%</p>)}
              {editState && (
                <input
                  type="number"
                  id="medicareTax"
                  name="medicareTax"
                  value={medicareTax}
                  placeholder="Medicare Taxes"
                  onChange={handleChange}
                  className={"input-error"}
                />
              )}
            </div>

            <div style={editState ? { gridTemplateColumns: "130px 1fr" } : undefined} className={`${classes.grid}`} >
              <label htmlFor="growthRate">
                <strong>Growth Rate:</strong>
              </label>
              {!editState && (<p>{growthRate}%</p>)}
              {editState && (
                <input
                  type="number"
                  id="growthRate"
                  name="growthRate"
                  value={growthRate}
                  placeholder="Growth Rate"
                  onChange={handleChange}
                  className={"input-error"}
                />
              )}
            </div>

            <div style={editState ? { gridTemplateColumns: "130px 1fr" } : undefined} className={`${classes.grid}`} >
              <label htmlFor="stateTax">
                <strong>State Taxes:</strong>
              </label>
              {!editState && (<p>{stateTax}%</p>)}
              {editState && (
                <input
                  type="number"
                  id="stateTax"
                  name="stateTax"
                  value={stateTax}
                  placeholder="State Taxes"
                  onChange={handleChange}
                  className={"input-error"}
                />
              )}
            </div>

            <div style={editState ? { gridTemplateColumns: "130px 1fr" } : undefined} className={`${classes.grid}`} >
              <label htmlFor="federalTax">
                <strong>Federal Taxes:</strong>
              </label>
              {!editState && (<p>{federalTax}%</p>)}
              {editState && (
                <input
                  type="number"
                  id="federalTax"
                  name="federalTax"
                  value={federalTax}
                  placeholder="Federal Taxes"
                  onChange={handleChange}
                  className={"input-error"}
                />
              )}
            </div>

            <div className="text-center flex justify-center gap-4 mt-8">
              {editState && (
                <BVAButton
                  onClick={() => {
                    handleCancel();
                  }}
                  type="button"
                  kind="primary-outlined"
                  className={classes.cancelBtnWidth}
                >
                  {" "}
                  Cancel{" "}
                </BVAButton>
              )}
              <BVAButton loading={loading} type="submit" kind="primary">
                {!editState ? "Edit Details" : "Submit Settings"}
              </BVAButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
